import React, {Component} from 'react';
import SplashHeader from "./SplashHeader";

import {ReactComponent as Thumb} from '../../../images/thumbs-up-black.svg'


class CreatePasswordSuccessful extends Component {
    render() {
        return (
            <div className="bac vh-100">
                <SplashHeader/>
                <div className="container  d-flex justify-content-around align-items-center pa3 mt-md-5 ">
                    <div className="box align-self-md-start  col-md-4 br4 border border-danger">
                        <div className=" col-12 col-md-12 d-flex ">
                            <div className="thumb">
                                <Thumb/>
                            </div>
                        </div>

                        <div className="text-area">
                            <h1 className="submit-text"> Almost there! </h1>
                            <p className="p-text"> You have created a new password.
                                Kindly click the button below to login and continue your application
                            </p>
                            <a href="/login">
                                <button className="next-button">Log In</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreatePasswordSuccessful;